import React from 'react';
import './FourFourFourAI.css';

function ThirukuralAI() {
  return (
    <div className="thirukural-ai-container">
      <div className="thirukural-ai-content">
        <h1 className="app-name">Thirukural AI</h1>
        <p className="tagline">AI based Thirukural Story and Audio App</p>
        
        <div className="intro-section">
          <p className="intro-text">
            Thirukural AI is an intelligent app that serves all 1330 kurals along with interactive text story and audio story. 
            The app is designed to provide an engaging and immersive experience for users who want to explore the wisdom of Thirukural in a modern and accessible way.
            With Thirukural AI, you can easily navigate through the vast collection of kurals, listen to audio narrations, and read interactive stories that bring the timeless teachings of Thirukural to life.
            Whether you're a student, a literature enthusiast, or simply curious about Thirukural, our app offers a unique and enriching way to connect with this ancient Tamil literary masterpiece.
          </p>
        </div>

        <div className="features-brief">
          <div className="feature-item">
            <span className="emoji">🧠</span>
            <h3>Intelligent Support</h3>
            <p>AI that understands and responds to your Thirukural learning needs</p>
          </div>
          <div className="feature-item">
            <span className="emoji">🎧</span>
            <h3>Immersive Experience</h3>
            <p>Engage with Thirukural through interactive stories and audio narrations</p>
          </div>
          <div className="feature-item">
            <span className="emoji">🎧</span>
            <h3>Audio Narration</h3>
            <p>Listen to Thirukural through engaging audio narrations</p>
          </div>
          <div className="feature-item">
            <span className="emoji">🎧</span>
            <h3>Premium Content</h3>
            <p>Access exclusive Thirukural stories and audio narrations</p>
          </div>
        </div>
        </div>
      </div>
  );
}

export default ThirukuralAI;
